import React from 'react';
import { Checkbox } from '../../../components/ui/checkbox';
import { Label } from '../../../components/ui/label';

const ColumnItem = ({ column, isSelected, onToggle, disabled }) => {
  return (
    <div className="flex items-center space-x-2 px-3 py-2 hover:bg-accent rounded-sm cursor-pointer">
      <Checkbox
        id={column.Field}
        checked={isSelected}
        onCheckedChange={() => onToggle(column.Field)}
        disabled={disabled}
      />
      <Label
        htmlFor={column.Field}
        className="text-sm font-normal cursor-pointer flex-1"
      >
        {column.Field}
      </Label>
    </div>
  );
};

export default ColumnItem;